// extracted by mini-css-extract-plugin
export default {"wrapper_body":"Community_wrapper_body__5EoAz"};